import React, { useEffect, useState } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { Swiper, SwiperSlide, Autoplay, Pagination, TypeSwiper } from '../../services/ImportsSwiper';
import './BlockCarousel.scss';
import './BlockCarousel-media.scss';
import { Props } from './interfaces';
import { MediaContent } from '../../services/GlobalFunctions';

const BlockCarousel = ({ title, list, widthWindow, offsetContent, noFade }: Props) => {
  const [numActiveSlide, setNumActiveSlide] = useState(1);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const Changed = (current: TypeSwiper) => {
    setNumActiveSlide(current.realIndex + 1);
    setIsBeginning(current.isBeginning);
    setIsEnd(current.isEnd);
  };

  const [slider, setSlider] = useState<TypeSwiper>();

  // Loop требует достаточно слайдов для корректной работы
  const enableLoop = list.length >= 5;

  const settings = {
    onInit: (slider: TypeSwiper) => setSlider(slider),
    autoplay: false,
    speed: 500,
    loop: enableLoop,
    modules: [Autoplay, Pagination],
    onSlideChange: Changed,
    className: 'slider-carousel',
    spaceBetween: 20,
  };

  const settingsMain = {
    ...settings,
    slidesPerView: 'auto' as const,
    centeredSlides: true,
    centeredSlidesBounds: true, // Не показывать пустоту по краям
  };

  const settingsMob = { ...settings, slidesPerView: 1, centeredSlides: true, width: widthWindow - 80 };

  const prevSlide = () => {
    if (slider) {
      slider.slidePrev(500, false);
    }
  };
  const nextSlide = () => {
    if (slider) {
      slider.slideNext(500, false);
    }
  };

  const listLong = list.length >= 5 ? [...list, ...list] : list;

  const stylesBlock = { transform: `translateX(-${offsetContent}px)` };

  const getSlideClass = (index: number) => {
    if (noFade) {
      return 'block-carousel__slide block-carousel__slide_active';
    }
    const isActive = index + 1 === numActiveSlide && list.length > 4;
    return `block-carousel__slide ${isActive ? 'block-carousel__slide_active' : 'block-carousel__slide_not-active'}`;
  };

  const handleSlideClick = (link?: string) => {
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  const content = (
    <>
      {listLong.map(({ image, title, text, link }, i) => (
        <SwiperSlide key={i}>
          <div
            className={`${getSlideClass(i)}${link ? ' block-carousel__slide--clickable' : ''}`}
            style={image ? { backgroundImage: `url(${image})` } : {}}
            onClick={() => handleSlideClick(link)}
          >
            <h4 className="block-carousel__slide-title">{title}</h4>
            <p className="body2" dangerouslySetInnerHTML={{ __html: text }}></p>
          </div>
        </SwiperSlide>
      ))}
    </>
  );

  return list.length ? (
    <div className="block-carousel" style={widthWindow > 720 && widthWindow < 1440 ? stylesBlock : {}}>
      <h2 className="block-carousel__title">{title}</h2>

      {MediaContent(
        <Swiper {...settingsMain}>
          {content}
          {!noFade && (
            <>
              <div className="block-carousel__gradient block-carousel__gradient_left" />
              <div className="block-carousel__gradient block-carousel__gradient_right" />
            </>
          )}

          {(enableLoop || !isBeginning) && (
            <div
              className="block-carousel__arrow block-carousel__arrow_prev"
              onClick={prevSlide}
              style={{ left: '20px' }}
            />
          )}
          {(enableLoop || !isEnd) && (
            <div
              className="block-carousel__arrow block-carousel__arrow_next"
              onClick={nextSlide}
              style={{ right: '20px' }}
            />
          )}
        </Swiper>,
        <Swiper {...settingsMob}>{content}</Swiper>
      )}
    </div>
  ) : null;
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(BlockCarousel));

const getPosArrow = (offsetContent: number) => {
  const slider = document.querySelector('.slider-carousel');
  if (slider) {
    const offsetBlock = slider.getBoundingClientRect().x;

    return offsetContent - offsetBlock;
  }

  return 0;
};
